import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from 'react-redux';
import { apiUploadForwardFile } from '@store';
import WarningIcon from '@mui/icons-material/Warning';
import { showToast } from '@utils';

const UploadFileModal = ({ handleClose }) => {
    const dispatch = useDispatch();
    const [File, setFile] = React.useState(null);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
        }
    };

    const handleFileRemove = () => {
        setFile(null);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('File', File);

        const resp = await dispatch(apiUploadForwardFile(formData));
        if (resp.meta?.requestStatus === 'fulfilled') {
            handleClose();
            setFile(null);
            showToast('success', 'File uploaded successfully');
        } else if (resp.meta?.requestStatus === 'rejected') {
            showToast('error', resp.payload);
        }
    };

    return (
        <Box
            className="modal-container"
            component="form"
            onSubmit={handleSubmit}
        >
            <Box className="flex justify-between modal-header">
                <h2 className="modal-title">Upload Forward File</h2>
                <CloseIcon className="cursor-pointer" onClick={handleClose} />
            </Box>
            <div className="modal-body">
                <div className="modal-input-group">
                    {/* if the file is not csv show the warning */}
                    {/* {file && file.type !== 'csv' && ( */}
                    <Box
                        className="modal-warning"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            backgroundColor: '#fff3cd',
                            color: '#856404',
                            padding: '10px',
                            borderRadius: '4px',
                            marginBottom: '10px'
                        }}
                    >
                        <WarningIcon />
                        <Typography variant="body2" sx={{ marginLeft: '5px' }}>
                            Please upload a CSV file.
                        </Typography>
                    </Box>
                    {/* )} */}
                    <Box
                        className="modal-file-upload"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '10px',
                            border: '1px solid #ccc',
                            borderRadius: '4px'
                        }}
                        component="label"
                        htmlFor="file-upload"
                    >
                        <input
                            type="file"
                            id="file-upload"
                            className="modal-input"
                            onChange={handleFileChange}
                        />
                    </Box>
                    {File && (
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                marginTop: '10px',
                                position: 'relative'
                            }}
                            className="modal-file-info"
                        >
                            <Box
                                className="modal-file-name"
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    width: '100%',
                                    padding: '10px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    marginTop: '10px',
                                    backgroundColor: '#f9f9f9',
                                    color: '#333',
                                    fontSize: '14px'
                                }}
                            >
                                {File.name}
                            </Box>
                            <Button
                                variant="outlined"
                                color="error"
                                size="small"
                                className="modal-remove-button"
                                onClick={handleFileRemove}
                                sx={{
                                    position: 'absolute',
                                    right: '10px',
                                    top: '60%',
                                    transform: 'translateY(-50%)'
                                }}
                            >
                                Remove
                            </Button>
                        </Box>
                    )}
                </div>
            </div>
            <div className="modal-footer">
                <Button
                    className="modal-button-secondary"
                    onClick={handleClose}
                >
                    Cancel
                </Button>
                <Button type="submit" className="modal-button-primary">
                    Submit
                </Button>
            </div>
        </Box>
    );
};

export default UploadFileModal;
